<template>
  <span :class="className">
    {{ $t(`voip.statuses.${status}`) }}
  </span>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('voip', ['status']),

    className() {
      return [
        'voip-status',
        `voip-status--${this.status}`,
        'inline-flex',
        'align-items-center',
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.voip-status {
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;

  &::after {
    content: '';
    display: block;
    width: 0.6em;
    height: 0.6em;
    margin-left: 0.5em;

    border-radius: 50%;
  }
}

.voip-status--unregistered::after {
  background-color: $danger-500;
}

.voip-status--busy::after {
  background-color: $warning-500;
}

.voip-status--registered::after {
  background-color: $success-500;
}

.voip-status--deviated::after {
  background-color: $warning-500;
}
</style>
